import type { SectionItem } from '@/types/components/section-item'

export const HOME_SECTION_ITEMS: SectionItem[] = [
	{
		id: 'content-1',
		icon: 'i-custom-speedometer',
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/home-content-aside-1.avif',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [
			{
				rotation: -15,
				length: 150,
				direction: 'counter-clockwise'
			}
		],
		circles: []
	},
	{
		id: 'content-2',
		icon: 'i-custom-home',
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/home-content-aside-2.avif',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [],
		circles: [
			{
				cx: 327,
				cy: 76,
				r: 61,
				fill: '#01629E'
			},
			{
				cx: 377.5,
				cy: 88,
				r: 21,
				fill: '#FF8A02'
			}
		]
	},
	{
		id: 'content-3',
		icon: 'i-custom-dollar-bill',
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/home-content-aside-3.avif',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [
			{
				rotation: -15,
				length: 150,
				direction: 'counter-clockwise',
				gap: 30,
				stroke: '#FF5733'
			}
		],
		circles: []
	},
	{
		id: 'content-4',
		icon: 'i-custom-csr',
		viewbox: {
			width: 405,
			height: 405
		},
		image: {
			url: '/home-content-aside-4.avif',
			alt: 'Maverix Fiber-fast internet'
		},
		lines: [],
		circles: [
			{
				cx: 327,
				cy: 76,
				r: 61,
				fill: '#01629E'
			},
			{
				cx: 377.5,
				cy: 88,
				r: 21,
				fill: '#FF8A02'
			}
		]
	}
]
